import { createContext, useEffect, useState } from 'react';

import axios from 'axios';
import { useContainer } from 'unstated-next';

import { GET_ERRORS } from '../../../../config/apiPaths';
import { getUserUuidHeaders } from '../../../../utils/httpUtils';
import { processApiPath } from '../../../../utils/url';
import AdminAuthContainer from '../../AdminAuthContainer';

interface TroubleshootingDetailErrorLogsContextInterface {
    isLoading: boolean;
    insightsDetailErrors: any[];
    allLoaded: boolean;
    timeSpan: string;
    updateTimeSpan: (s: string) => void;
}

const TroubleshootingDetailErrorLogsContext = createContext(
    undefined as unknown as TroubleshootingDetailErrorLogsContextInterface
);

const { Provider, Consumer } = TroubleshootingDetailErrorLogsContext;

const TroubleshootingDetailErrorLogsProvider = ({ children }) => {
    const search = new URLSearchParams(window.location.search);
    const userUuid = search.get('user_uuid') || window.localStorage.getItem('user_uuid');

    const { authMode, showDemoContent } = useContainer(AdminAuthContainer);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [allLoaded, setAllLoaded] = useState<boolean>(false);
    const [insightsDetailErrors, setInsightsDetailErrors] = useState<any>([]);
    const [timeSpan, setTimeSpan] = useState(window.localStorage.getItem('timeSpan') || 'week');

    const updateTimeSpan = (s: string) => {
        setTimeSpan(s);
        window.localStorage.setItem('timeSpan', s);
        setIsLoading(true);
        setAllLoaded(false);
    };

    useEffect(() => {
        const loadInner = async () => {
            console.log('isLoading', isLoading);
            if (!isLoading || allLoaded) {
                return;
            }
            const { data } = await axios.get(
                processApiPath(GET_ERRORS, undefined, {
                    auth_mode: authMode,
                    demo_content: String(showDemoContent),
                    time_span: timeSpan
                }),
                { headers: getUserUuidHeaders(userUuid as string) }
            );
            setInsightsDetailErrors(data);
            setIsLoading(false);
            setAllLoaded(true);
        };
        loadInner();
    }, [authMode, userUuid, showDemoContent, isLoading, allLoaded, setInsightsDetailErrors, setAllLoaded, timeSpan]);

    return (
        <Provider
            value={{
                insightsDetailErrors,
                isLoading,
                allLoaded,
                timeSpan,
                updateTimeSpan
            }}
        >
            {children}
        </Provider>
    );
};

export {
    TroubleshootingDetailErrorLogsContext,
    TroubleshootingDetailErrorLogsProvider,
    Consumer as TroubleshootingDetailErrorLogsConsumer
};
